export default "__VITE_ASSET__BKsVSjNl__"